import 'twin.macro';
import React from 'react';
import _isEmpty from 'lodash-es/isEmpty';
import { ProgrammationSearchResult } from '@teetsh/app/src/containers/Search/types';
import HtmlViewer from '@teetsh/app/src/components/HtmlViewer';
import { Tag } from '@teetsh/app/src/components/Tag';
import { Color } from '@teetsh/app/src/types/colors';

interface Props {
  programmation: ProgrammationSearchResult;
}

function notGray200Color(color: Color) {
  if (color === 'gray-200') {
    return 'gray-500';
  }
  return color;
}

export function ProgrammationPreview(props: Props) {
  const { programmation } = props;
  return (
    <div tw="p-6">
      <div tw="text-xl font-bold mb-4">{programmation.name}</div>
      <div tw="space-y-3">
        {(programmation.items || []).map(ev => (
          <div tw="bg-neutral-quiet rounded-lg p-3 text-xs" key={ev.id}>
            <div tw="float-right mb-1">
              <div tw="inline-flex flex-wrap gap-1">
                {!_isEmpty((ev.matiereName || '').trim()) && (
                  <Tag tw="block" color={notGray200Color(ev.matiereColor)}>
                    {ev.matiereName}
                  </Tag>
                )}
                {!_isEmpty((ev.domaineName || '').trim()) && (
                  <Tag tw="block" color={notGray200Color(ev.domaineColor)}>
                    {ev.domaineName}
                  </Tag>
                )}
                {!_isEmpty((ev.periodeName || '').trim()) && (
                  <Tag tw="block" color={notGray200Color(ev.periodeColor)}>
                    {ev.periodeName}
                  </Tag>
                )}
              </div>
            </div>
            <HtmlViewer onChange={() => {}} text={ev.value} />
          </div>
        ))}
      </div>
      {programmation.nbOfItems > 10 && (
        <div tw="text-center text-4xl text-muted">...</div>
      )}
    </div>
  );
}
